import chalk from 'chalk'
import { diffChars } from 'diff'

export const getDiff = (base: string, compare: string): string => {
  const changes = diffChars(base, compare)
  const hasChanges = changes.some(change => {
    return change.added || change.removed
  })
  if (hasChanges) {
    return changes.reduce((diffString: string, part) => {
      diffString += part.added ? chalk.green(part.value) :
        part.removed ? chalk.red(part.value) : chalk.grey(part.value);
      return diffString
    }, '')
  }
  return ''
}
